export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-accent-50/40 via-background-50 to-secondary-50/30"></div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-0">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-5">
              <i className="ri-fire-line"></i>
              <span>今日已更新 87 条爆料</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              每日大瓜 · 全网爆料一网打尽
            </h1>

            <p className="text-sm text-foreground-500 leading-relaxed mb-2">
              不生产瓜，只做瓜的搬运工
            </p>

            <div className="max-w-xl mx-auto lg:mx-0">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
                每日大瓜聚焦每日爆料吃瓜与吃瓜每日的新鲜感，整合娱乐爆料、网友爆料、社会圈内猛料，覆盖明星动态、综艺热点、网红翻车、行业大瓜等多元话题。以文字截图摘要形式呈现，省时省力天天不重样，让你第一时间掌握圈内最新动态。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 mb-6">
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-timer-line text-accent-500"></i>
                <span>每日早 8 点准时更新</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-global-line text-accent-500"></i>
                <span>覆盖 30+ 信源渠道</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-shield-check-line text-accent-500"></i>
                <span>匿名投稿安全保障</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-flashlight-line"></i>
                立即吃瓜
              </a>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 font-medium text-sm rounded-lg hover:bg-background-200 transition-colors border border-background-300/60 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line"></i>
                我要爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20modern%20illustration%20of%20social%20media%20gossip%20and%20entertainment%20news%20aggregation%2C%20warm%20orange%20and%20coral%20tones%2C%20abstract%20geometric%20shapes%20representing%20news%20bubbles%20and%20communication%2C%20minimalist%20flat%20design%2C%20clean%20composition%20with%20speech%20bubbles%20and%20megaphone%20elements%2C%20digital%20art%20style%2C%20soft%20gradients%2C%20Chinese%20internet%20culture%20vibe%2C%20light%20cream%20background&width=800&height=600&seq=hero-daily-melon-01&orientation=landscape"
                alt="每日大瓜娱乐爆料聚合平台"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}